import React, {Component, ReactElement, ReactNode} from 'react'

import NatCondominiumRepo from './repository/NatCondominiumRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {PageFooterArea, PageFotterAreaRight, PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {
    CondominiumFacilityReserveIntroductoryData,
    NatGetCondominiumFacilityReserveIntroductory,
} from './repository/NatGetCondominiumFacilityReserveIntroductory'
import {
    NatPutCondominiumFacilityReserveIntroductoryResponse,
} from './repository/NatPutCondominiumFacilityReserveIntroductory'
import {Messages} from '../../../Messages'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import {judgeAuthorityCheck} from '../../common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {Location} from 'react-router-dom'


interface Props {
    condominiumCd: string
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    isLoadCompleted: boolean
    condominiumFacilityReserveIntroductory: CondominiumFacilityReserveIntroductoryData
    showInitialMessage: boolean
}

class NatAdminCondominiumFacilityReserveIntroductoryPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            isLoadCompleted: false,
            condominiumFacilityReserveIntroductory: {
                condominiumCd: '',
                facilityReserveIntroductory: '',
                version: 0,
            },
            showInitialMessage: false,
        }


        this.onClickEditButton = this.onClickEditButton.bind(this)
        this.editButtonCancelClick = this.editButtonCancelClick.bind(this)
        this.editButtonOkClick = this.editButtonOkClick.bind(this)
        this.changeFacilityReserveIntroductory = this.changeFacilityReserveIntroductory.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // 物件施設予約紹介文取得
            const getCondominiumFacilityReserveIntroductoryResponse:
                Nullable<NatGetCondominiumFacilityReserveIntroductory> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumFacilityReserveIntroductory.bind(
                    this.props.condominiumRepo,
                    this.props.condominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (getCondominiumFacilityReserveIntroductoryResponse &&
                getCondominiumFacilityReserveIntroductoryResponse.details) {
                this.setState({
                    condominiumFacilityReserveIntroductory: getCondominiumFacilityReserveIntroductoryResponse.details,
                })
            }

            this.showInitialMessage()

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        } else if (this.props.location.state.showInitialMessage) {
            const initialMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0008.toString('施設予約紹介文'),
            }
            this.props.navigate(this.props.location.pathname, {replace: true})
            this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
            this.props.eventEmitter.closeLoading()
        }
    }


    changeFacilityReserveIntroductory(value: string): void {
        const condominiumFacilityReserveIntroductory = this.state.condominiumFacilityReserveIntroductory
        condominiumFacilityReserveIntroductory.facilityReserveIntroductory = value
        this.setState({condominiumFacilityReserveIntroductory: condominiumFacilityReserveIntroductory})
    }

    editButtonCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async editButtonOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const putCondominiumFacilityReserveIntroductoryResponse:
                Nullable<NatPutCondominiumFacilityReserveIntroductoryResponse> =
                await this.props.asyncCallFunction(
                    this.props.condominiumRepo.putCondominiumFacilityReserveIntroductory.bind(
                        this.props.condominiumRepo, this.state.condominiumFacilityReserveIntroductory,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('施設全体説明')},
                )
            if (putCondominiumFacilityReserveIntroductoryResponse &&
                putCondominiumFacilityReserveIntroductoryResponse.requestError === null) {
                this.props.navigate(        // TODO ReactVUP: 動作確認する
                    this.props.location.pathname,
                    {
                        state: {
                            showInitialMessage: true,
                        },
                    },
                )
                window.location.reload()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async onClickEditButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('施設予約紹介文'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.editButtonCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.editButtonOkClick,
                    },
                ],
            },
        )
    }


    renderPageBody(): ReactElement {
        return (
            <>
                <Box marginTop={'10px'}>
                    <Table>
                        <StyledTableCaption>施設情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName>施設予約紹介文</TableRowName>
                                <TableCell>
                                    {judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_TOTAL_DESCRIPTION) &&
                                        <PPHtmlEditor
                                            onEditorChange={this.changeFacilityReserveIntroductory}
                                            value=
                                                // tslint:disable-next-line:max-line-length
                                                {this.state.condominiumFacilityReserveIntroductory.facilityReserveIntroductory}
                                            eventKeys={['facilityReserveIntroductory']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    }
                                    {!judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_TOTAL_DESCRIPTION) &&
                                        <div dangerouslySetInnerHTML=
                                                 // tslint:disable-next-line:max-line-length
                                                 {{__html: this.state.condominiumFacilityReserveIntroductory.facilityReserveIntroductory}}>
                                        </div>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </>
        )
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        onClick={this.onClickEditButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    {this.renderPageBody()}
                </PageMainArea>
                {judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_TOTAL_DESCRIPTION) &&
                    <PageFooterArea>
                        {this.renderPageFooterArea()}
                    </PageFooterArea>
                }
            </>
        )
    }

}


export default createAdminPage(NatAdminCondominiumFacilityReserveIntroductoryPage)
